import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs';

export interface ApiError {
  status: number;
  message: string;
  fieldErrors: Record<string, string> | null;
  errorId: string | null;
}

export function parseApiError(err: HttpErrorResponse): ApiError {
  const body = err.error;
  const message = body?.message || err.message || 'Unknown error';
  const refMatch = message.match(/\[([a-f0-9]{8})\]$/);
  return {
    status: err.status,
    message,
    fieldErrors:
      err.status === 400 && body?.data && typeof body.data === 'object'
        ? (body.data as Record<string, string>)
        : null,
    errorId: refMatch ? refMatch[1] : null,
  };
}

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith('./assets/') || req.url.startsWith('/assets/')) {
    return next(req);
  }

  return next(req).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        const apiError = parseApiError(error);
        (error as HttpErrorResponse & { apiError: ApiError }).apiError = apiError;
      },
    }),
  );
};
